<!--
 * @Author: DY
 * @Date: 2025-03-03 16:59:49
 * @LastEditTime: 2025-03-18 17:47:59
 * @Description: 销售异议处理【销售管理】
 * @FilePath: \ShiMo_Mobile\src\views\sales\salesObjectionHandling\index.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="salesObjectionHandling commonListStyles">
            <HeaderNav
                header-title="销售异议处理"
                left-icon-name="2"
                right-icon-name="5"
                :extr="{ rightCallBack: toDetail, iconName: 'sm-icon-test' }"
            ></HeaderNav>
            <section>
                <van-search v-model="keyVal" placeholder="请输入搜索信息" @change="onRefresh"></van-search>
                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                        v-model="isUpLoading"
                        finished-text="没有更多了!"
                        :finished="finished"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <li class="listItem" v-for="(item,index) in listData" :key="`item_${index}`">
                                <div class="engineeringInfo">
                                    <h4 class="itemTitle">
                                        <span class="iconfont iconhetong">异议处理单号：{{ item.objection_number }}</span>
                                    </h4>
                                    <p class="itemStatus">
                                        {{ item.approve_status_name }}
                                    </p>
                                    <div class="itemContent">
                                        <p>
                                            <img src="@/assets/images/icons/icon_1@2x.png" alt="">
                                            <span>汽运单号：{{ item.transport_number }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_2@2x.png" alt="">
                                            <span>单据日期：{{ item.creation_time }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_29@2x.png" alt="">
                                            <span>客户名称：{{ item.client_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_5@2x.png" alt="">
                                            <span>物料：{{ item.material_short_name }}</span>
                                        </p>
                                        <p>
                                            <img src="@/assets/images/icons/icon_38@2x.png" alt="">
                                            <span>误差比：{{ item.error_ratio }}</span>
                                        </p>
                                    </div>
                                    <div class="itemBtn itemBtns">
                                        <van-button
                                            plain
                                            type="danger"
                                            v-if="item.approve_status == 0"
                                            @click="toDetail(item, 'edit')"
                                        >
                                            办理
                                        </van-button>
                                        <van-button
                                            plain
                                            type="danger"
                                            v-else
                                            @click="toDetail(item, 'view')"
                                        >
                                            查看
                                        </van-button>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </van-list>
                </van-pull-refresh>
            </section>
        </div>
    </v-touch>
</template>

<script>
import { mixin_list } from '@/assets/mixin/mixin_list';
export default {
    name: 'sales-objection-handling',
    mixins: [mixin_list],
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.$store.commit('noKeepAlive', 'sales-objection-handling');
        }
        next();
    },
    data() {
        return {
            tableCode: 'delivery_objection_list',
        };
    },
    watch: {},
    activated() {
        if (this.$route.params.isRefresh) {
            this.onRefresh();
        }
    },
    created() {
        this.cacheKey = Math.floor(Math.random() * 1000000000000 + 1);
    },
    mounted() {},
    computed: {},
    methods: {
        toDetail(item = null, type = 'add') {
            this.$router.isBack = 2;
            this.$router.push({
                name: 'salesObjectionHandlingForm',
                params: {
                    data: item,
                    type,
                },
            });
        },
    },
    updated() {},
    destroyed() {},
};
</script>

<style lang="stylus" scoped>
.salesObjectionHandling
    width 100%
    height 100%
    background #F0F0F0
    .van-nav-bar
        .van-nav-bar__title
            div
                display inline-block
                padding 0 15rpx
                font-size 14rpx
                color rgba(240,240,240,0.7)
                transition 0.2s
                &.active
                    font-size 18rpx
                    color #fff
</style>
